export default "<footer>Footer Works!</footer>\n"